const linkGenerators = document.querySelectorAll('.link-generator');

function getActiveUrlComp(group) {
    return group?.querySelector('button.active')?.dataset.urlComp;
}

function buildLink(marketUrl, timelineSuffix) {
    return `${marketUrl.replace(/\/+$/, '')}/${timelineSuffix.replace(/^\/+/, '')}`;
}

linkGenerators.forEach((section) => {
    const timelineGroup = section.querySelector('.timeline-selectors');
    const locationGroup = section.querySelector('.location-selectors');

    [timelineGroup, locationGroup].forEach((group) => {
        if (!group) return;

        group.addEventListener('click', (event) => {
            const button = event.target.closest('button[data-url-comp]');
            if (!button || !group.contains(button)) return;

            group.querySelectorAll('button[data-url-comp]').forEach((btn) => {
                const isActive = btn === button;
                btn.classList.toggle('active', isActive);
                btn.setAttribute('aria-pressed', isActive);
            });

            const timelineSuffix = getActiveUrlComp(timelineGroup);
            const marketUrl = getActiveUrlComp(locationGroup);

            if (timelineSuffix && marketUrl) {
                window.location.href = buildLink(marketUrl, timelineSuffix);
            }
        });
    });
});
